<template>
  <div class="profile-ud-list">
    <slot></slot>
  </div>
</template>

<script>
export default {

}
</script>
